import React from 'react'
import styled, { css } from 'styled-components'

export const Card = styled.button`
	width: 100%;
	max-width: 345px;
	background: ${props => props.theme.colors.brand.white};
	border: 1px solid ${props => props.theme.colors.greys.dividerGray};
	border-radius: 12px;
	padding: 32px 24px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: ${props => (props.$rounded ? '16px' : '4px')};
	cursor: pointer;
	transition: all 0.2s;
	flex: 1;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		background: ${props =>
			props.$fullMobileCard ? props.theme.colors.brand.white : 'transparent'};
		border: ${props =>
			props.$fullMobileCard ? `1px solid ${props.theme.colors.greys.dividerGray}` : '0px'};
		padding: ${props => (props.$fullMobileCard ? '24px 16px' : '0px 0px')};
		gap: ${props => (props.$fullMobileCard ? '12px' : '10px')};
		max-width: 100%;
	}
`

export const IconWrapper = styled.div`
	width: ${({ size }) => size || '64px'};
	height: ${({ size }) => size || '64px'};
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 12px;
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		background: ${props =>
			props.$rounded || props.$fullMobileCard
				? 'transparent'
				: props.theme.colors.brand.white};
		border: ${props =>
			props.$rounded || props.$fullMobileCard
				? '0px'
				: `1px solid ${props.theme.colors.greys.dividerGray}`};
		width: ${props => (props.$rounded ? '40px' : props.$fullMobileCard ? '24px' : '100%')};
		max-width: ${props => (props.$rounded ? '40px' : props.$fullMobileCard ? '24px' : '190px')};
		height: ${props => (props.$rounded ? '40px' : props.$fullMobileCard ? '24px' : '64px')};
	}
`

export const CardTextWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4px;
`

export const AccessIcon = styled.div`
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 12px;

	${props =>
		props.$rounded &&
		css`
			width: 48px;
			height: 48px;
			border-radius: 50%;
			background: ${props.theme.colors.brand.lightGreen};

			@media (max-width: ${props.theme.sizes.breakPoints.small}) {
				width: 40px;
				height: 40px;
			}
		`}
`

export const AccessGrid = styled.div`
	display: flex;
	flex-direction: row;
	gap: 16px;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		display: grid;
		grid-template-columns: repeat(${({ mobileColumns }) => mobileColumns || 2}, 1fr);
	}
`
